import Vue from 'vue';
import Vuex from 'vuex';
import currentState from './modules/currentState';
import formData from './modules/formData';
import pageData from './modules/pageData';
import referrerContext from './modules/referrerContext';
import userContext from './modules/userContext';
import storageInfo from './modules/storageInfo';
import secondaryUserContext from './modules/secondaryUserContext';
import globalData from './modules/globalData';
import trustPendingRecord from './modules/trustPendingRecord';
import trustSignerStatus from './modules/trustSignerStatus';

Vue.use(Vuex);
Vue.prototype.$globalData = globalData;
Vue.prototype.$dpTogglesObj = window.dpTogglesObj;

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    routeId: '',
    locale: '',
  },
  modules: {
    currentState,
    formData,
    pageData,
    referrerContext,
    userContext,
    storageInfo,
    trustPendingRecord,
    trustSignerStatus,
    secondaryUserContext,
  },
  getters: {
    routeId: (state) => state.routeId,
    locale: (state) => state.locale,
    queryParams: (state) => state.queryParams,
  },
  mutations: {
    SET_ROUTEID: (state, payload) => {
      state.routeId = payload;
    },
    SET_LOCALE: (state, payload) => {
      state.locale = payload;
    },
    SET_QUERYPARAMS: (state, payload) => {
      state.queryParams = payload;
    },
  },
  actions: {
    set_routeId: (context, payload) => {
      context.commit('SET_ROUTEID', payload);
    },
    set_locale: (context, payload) => {
      context.commit('SET_LOCALE', payload);
    },
    set_queryParams: (context, payload) => {
      context.commit('SET_QUERYPARAMS', payload);
    },
  },
});
